module.exports = __webpack_public_path__ + "img/1183.52b5ccb5.gif";